import bulletCam from './bulletCam.jpg'
import doorbellE340 from './doorbellE340.jpg'
import entrySensor from './entrySensor.jpg'
import famiLock from './famiLock.jpg'
import glassBreakSensor from './glassBreakSensor.jpg'
import homebase from './homebase.jpg'
import homebase3 from './homebase3.jpg'
import indoorCameraE220 from './indoorCameraE220.jpg'
import indoorCameraS350 from './indoorCameraS350.jpg'
import keyFobE10 from './keyFobE10.jpg'
import keypad from './keypad.jpg'
import medicalPendant from './medicalPendant.jpg'
import motionDetector from './motionDetector.jpg'
import nvrStorage from './nvrStorage.jpg'
import s4Max from './s4Max.jpg'
import samsungTvGeneric from './samsungTvGeneric.jpg'
import smartLockC220 from './smartLockC220.jpg'
import smartPanel from './smartPanel.jpg'
import smoke from './smoke.jpg'
import solarS4Camera from './solarS4Camera.jpg'
import solarS340Camera from './solarS340Camera.jpg'
import soloCamE30 from './soloCamE30.jpg'
import soloCamS220 from './soloCamS220.jpg'
import turretE41 from './turretE41.jpg'

// Keyed by the exact Firebase product `type`/label string (Misc/env/security_*
// dropdowns). Reference photos, not customer-specific media — see T49.
export const productPhotoMap: Readonly<Record<string, string>> = {
  'Bullet Cam E40 (PoE)': bulletCam,
  'Door Sensors': entrySensor,
  'Window Sensors': entrySensor,
  'Garage Sensor': entrySensor,
  'Doorbell E340': doorbellE340,
  'FamiLock Doorbell + Lock': famiLock,
  // eufy Glass Break Sensor E10 (t90g0121), official eufy.com image, 2026-09-23
  // photo audit: live selectable product that showed no photo at all.
  // Replaced 2026-10-18 with the uncropped eufy.com image (the old file was cut
  // on the left; Jaron, Oct 14: "make glassbreak and motion full pictures").
  'Glass Break Sensor': glassBreakSensor,
  Homebase: homebase,
  'HomeBase 3': homebase3,
  'Indoor Camera E220': indoorCameraE220,
  'Indoor Camera S350': indoorCameraS350,
  'eufy Key Fob E10': keyFobE10,
  Keypad: keypad,
  'Medical Pendant': medicalPendant,
  'Motion Detector': motionDetector,
  // nvrStorage / s4Max replaced 2026-10-07 with official eufy images at
  // 1200px (NVR S4 t8n00144, Bullet-PTZ Cam S4 t8e00121): the NVR file was
  // cropped on the right and the S4 Max was 191x265, so the full-screen
  // viewer showed them cut and blurry (Jaron, Oct 5 "it's cut" and Oct 6
  // "Better pictures").
  'NVR (Network Video Recorder)': nvrStorage,
  '2 TB Video Storage System': nvrStorage,
  '4 TB Video Storage System': nvrStorage,
  '8 TB Video Storage System': nvrStorage,
  '16 TB Video Storage System': nvrStorage,
  'S4 Max Camera (PoE)': s4Max,
  // Generic stock photo, same approach eufy itself uses across near-identical
  // SKUs (see T49) — Samsung doesn't have per-model photos sourced yet.
  'Samsung Crystal UHD': samsungTvGeneric,
  'Samsung QLED Q60A': samsungTvGeneric,
  'Samsung QLED Q70B': samsungTvGeneric,
  'Samsung Neo QLED QN85C': samsungTvGeneric,
  'Samsung Neo QLED QN90C': samsungTvGeneric,
  'Samsung The Frame': samsungTvGeneric,
  'Samsung QLED QN100C': samsungTvGeneric,
  'Smart Lock C220': smartLockC220,
  'Smart Panel': smartPanel,
  Smoke: smoke,
  'Solar S4 Camera': solarS4Camera,
  'Solar S340 Camera': solarS340Camera,
  // Kept only for any pre-existing customer record still carrying the
  // discontinued label (see B71) — not selectable in the live catalog.
  'SoloCam E30': soloCamE30,
  'SoloCam S220': soloCamS220,
  'Turret E41 (PoE)': turretE41,
}
